import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Button, Alert, Spinner, Row, Col } from "react-bootstrap";

import axiosOrganizationInstance from "./AxiosOrganizationInstance";
import FloatingLabelInput from "../restaurant/PlaceHolder";

import styles from "./css/school-signin.module.css"; // Import CSS Module for scoped styles

// Import images (if needed for your design)
import logo from "./assets/junior-eats-logo.png";
import bike from "./assets/bike.png";
import restaurant from "./assets/Restaurant.png";
import children from "./assets/children.png";


const Forgotpasswords = ({ onLogin }) => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(new Array(6).fill("")); // OTP array
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const nextStep = () => setStep((prevStep) => prevStep + 1);

  const handleEmailSubmit = async (email) => {
    console.log('Test', email)
    setEmail(email);
    setLoading(true);
    setError(null);
  
    try {
      console.log("Payload:", { identifier: email, purpose: "forgotpassword" });

      const response = await axiosOrganizationInstance.post("/request", {
        identifier: email,
        purpose: "forgotpassword", // Ensure the purpose is included and correct
      });
    
      if (response.status === 200) {
        nextStep(); // Proceed to the next step
        console.log('hello',200)
      } else {
        setError(response.data.message); // Handle server errors
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Failed to send verification code. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };
  

  const handleChange = (element, index) => {
    const value = element.value.replace(/[^0-9]/g, ""); // Only allow numbers
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move focus to the next input box automatically if the user enters a digit
    if (value && element.nextSibling) {
      element.nextSibling.focus();
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace") {
      // If backspace is pressed, move focus to the previous input box
      if (index > 0 && !otp[index]) {
        event.preventDefault();
        document.getElementsByClassName("otp-box")[index - 1].focus();
      }
    }
  };

  const handleResendOtp = async () => {
    console.log("Resend OTP clicked");
    setLoading(true);
    setError(null);
    try {
      const response = await axiosOrganizationInstance.post("/request", {
        identifier: email,
        purpose: "forgotpassword",
      });
      if (response.status === 200) {
        setError(null);
      } else {
        setError(response.data.message);
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Failed to resend verification code. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
    const enteredOtp = otp.join("");
    console.log("Entered OTP:", enteredOtp);

    setLoading(true);
    setError(null);

    try {
      const response = await axiosOrganizationInstance.post("/verify", {
        identifier: email,
        otp: enteredOtp,
      });

      if (response.status === 200) {
        setError(null); // Clear any previous error
        nextStep(); // Move to case 3
      } else {
        setError(response.data.message || "OTP verification failed.");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Invalid OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordSubmit = async () => {
    setLoading(true);
    setError(null);

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      setLoading(false);
      return;
    }

    try {
      const response = await axiosOrganizationInstance.post("/reset-password", {
        email: email,
        newPassword: confirmPassword,
      });

      if (response.status === 200) {
        setError(null);
        navigate("/organization/signin");
      } else {
        setError(response.data.message || "Password reset failed.");
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Password reset failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              handleEmailSubmit(email);
            }}
            
          >
            <h2 style={{ marginBottom: "20px" }}>organization</h2>

            {error && <Alert variant="danger">{error}</Alert>}
            <Form.Group className={styles.register_step2}>
              <FloatingLabelInput
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                label="Enter your email"
                isRequired={true}
              />
            </Form.Group>
            <br />
            <Button type="submit" className={styles.button1}>
              Submit
            </Button>
            <br />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <p style={{ marginTop: "14px" }}>Remembered Password? </p>
              <a
                href="/organization/signin"
                style={{
                  textDecoration: "none",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                Sign In
              </a>
            </div>
          </Form>
          
        );
      case 2:
        return (
            <Form
            onSubmit={handleOtpSubmit}
          >
            <h2 style={{ marginBottom: "20px" }}>organization</h2>

            {error && <Alert variant="danger">{error}</Alert>}
            <p className="otp-instruction">Enter the OTP sent to your email</p>
            {/* OTP Input Boxes */}
          <div className="otp-box-container" style={{marginBottom:'40px',width:'100%',display:'flex',flexDirection:'row',justifyContent:'space-around',padding:'0',marginLeft:'-5px'}}>
               {otp.map((value, index) => (
                 <input
                   key={index}
                  //  style={{width:'20%'}}
                  type="text"
                  maxLength="1"
                  className="otp-box"
                  value={value}
                  onChange={(e) => handleChange(e.target, index)}
                  onFocus={(e) => e.target.select()} // Select content on focus
                  onKeyDown={(e) => handleKeyDown(e, index)} // Detect backspace to move focus
                />
              ))}
            </div>

            
            <Button type="submit" className={styles.button1}>
              Verify OTP
            </Button>
            <br />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <p style={{ marginTop: "14px" }}>Didn't receive the OTP?{" "}<span style={{fontWeight:'bold',color:'#007bff',fontSize:'14px',cursor:'pointer'}}  onClick={handleResendOtp}>Resend OTP</span> </p>

              {/* <button
                type="button"
                className={styles.button1}
                onClick={handleResendOtp}
              >
                Resend OTP
              </button> */}
            </div>
          </Form>
            );
      case 3:
        return (
            <Form
            onSubmit={(e) => {
                      e.preventDefault();
                      handlePasswordSubmit();
                    }}
          >
         {error && <Alert variant="danger">{error}</Alert>}
            <h2 style={{ marginBottom: "30px" }}>organization</h2>

           
            <Form.Group className={styles.register_step2}>
            <FloatingLabelInput
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                label="Create a new password"
                isRequired={true}
              /><br/>
              <FloatingLabelInput
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                label="Confirm your password"
                isRequired={true}
              />
            </Form.Group>
            <br />
            <Button type="submit" className={styles.button1}>
            Save
            </Button>           
            
          </Form>
        );
      default:
        return null;
    }
  };

  return (
    <div className={styles.container}>
      {/* Left section: Background and visuals */}
      <div className={styles.leftSection}>
        <div className={styles.imageGroup}>
          <img src={bike} alt="bike" className={styles.bike} />
          <img
            src={restaurant}
            alt="Restaurant"
            className={styles.restaurant}
          />
          
          <img
            src={children}
            alt="Children Eating"
            className={styles.children}
          />
        </div>
      </div>

      {/* Right section: Login form */}
      <div className={styles.rightSection}>
        <img src={logo} alt="Junior Eats Logo" className={styles.logo} />
        <div className={styles.register_form}>
          {/* <form onSubmit={handleLogin} className={styles.form}> */}
          {loading && <div className="loading-spinner">Loading...</div>}
          {renderStep()}
        </div>
      </div>
    </div>
  );
};

export default Forgotpasswords;
